import { ICS_FILENAME } from "./contract";
import { ICS_MIME_TYPE, ICS_REVOKE_DELAY_MS } from "./constants";

/** Saves an iCalendar string as `appointment.ics` ("Add to calendar"); opens it where downloads are unsupported. */
export function downloadIcs(ics: string, filename: string = ICS_FILENAME): void {
  const url = URL.createObjectURL(new Blob([ics], { type: ICS_MIME_TYPE }));
  const anchor = document.createElement("a");
  if ("download" in anchor) {
    anchor.href = url;
    anchor.download = filename;
    anchor.hidden = true;
    document.body.append(anchor);
    anchor.click();
    anchor.remove();
  } else {
    window.open(url, "_blank", "noopener");
  }
  window.setTimeout(() => {
    URL.revokeObjectURL(url);
  }, ICS_REVOKE_DELAY_MS);
}
